import React, { useEffect, useRef, useState } from "react";

import { Link, useLocation } from "react-router-dom";
import style from "./homeheader.module.css";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../../../utils/api";
import {
  Button,
  Col,
  Dropdown,
  Nav,
  Navbar,
  Offcanvas,
  Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../../customHook/useGetUser";
import { logout } from "../../../../apis/authApis";
import { HiMenu } from "react-icons/hi";
import { MdClose } from "react-icons/md";

const HomeHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getToken();

  useGetUser();
  const [show, setShow] = useState(false);
  const { user } = useSelector((state) => state.user);
  const dropdownRef = useRef(null);

  const [active, setActive] = useState();
  const [showDropdown, setShowDropdown] = useState(false);

  const [showAboutDropdown, setShowAboutDropdown] = useState(false);

  const [expanded, setExpanded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false); // Close the sidebar if clicked outside
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    setActive(location.pathname);
  }, [location]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const scrollToSection = (id) => {
    navigate(`/aboutus#${id}`);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setShowAboutDropdown(false); // Close the dropdown after scrolling
      setIsOpen(false);
    }
  };

  const isBookSponsorshipPage =
    location.pathname.replace(/\/$/, "") === "/checkout";

  return (
    <>
      <div className="position-relative ">
        <div
          className={`position-absolute bg-white border rounded-1 p-3 px-md-4 py-md-3 fixed-top innercontainer ${
            isBookSponsorshipPage ? "book-sponsorship-navbar" : "my-4"
          }`}
          style={isBookSponsorshipPage ? { top: "45px", marginTop: "0px" } : {}}
        >
          <div className="d-flex  justify-content-between align-items-center  ">
            <Link to="/">
              <img src="/fundlifelogonew.svg" alt="logo" />
            </Link>
            {/* <div className=" d-none d-md-flex gap-4  gap-lg-5 justify-content-center py-1 py-md-0">
              <Nav.Link
                as={Link}
                to="/"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/" && style.navActive
                } `}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/aboutus/"
                className={`fs14 fw-medium  ${style.navBarlink} ${
                  active === "/aboutus/" && style.navActive
                }`}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/search-campaign"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/search-campaign" && style.navActive
                }`}
              >
                Campaigns
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/churches"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/churches" && style.navActive
                }`}
              >
                Churches
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/pricing"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/pricing" && style.navActive
                }`}
              >
                Pricing
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contactus"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/contactus" && style.navActive
                }`}
              >
                Contact Us
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/live-streams"
                className={`fs14 fw-medium ${style.navBarlink} ${
                  active === "/live-streams" && style.navActive
                }`}
              >
                Live Streams
              </Nav.Link>
            </div>

            <div className="d-none d-md-flex  gap-2 justify-content-end mt-3 mt-md-0">
              {!token && (
                <Button
                  variant="light"
                  className="px-4 fs14"
                  onClick={() => {
                    setActive();
                    navigate("/login");
                  }}
                >
                  Log in
                </Button>
              )}

              {token && (
                <div className=" position-relative" ref={dropdownRef}>
                  <Button
                    className="px-4 fs14"
                    variant="light"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    {user?.firstName}
                  </Button>
                  <Dropdown.Menu
                    className={` ${style.drpdown}`}
                    show={showDropdown}
                  >
                    <Dropdown.Item
                      onClick={() => {
                        handleToggle();
                        setShowDropdown(false);
                        setActive();
                        setExpanded(false); // Close the navbar only after the action
                        navigate("/profile");
                      }}
                    >
                      View Profile
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setShowDropdown(false);
                        setExpanded(false); // Close the navbar only after the action
                        dispatch(logout({ navigate }));
                      }}
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </div>
              )}

              <Button
                variant="danger redbtn px-4 fs14"
                onClick={() => {
                  setActive();
                  navigate("/campaign-register");
                }}
              >
                Register Campaign
              </Button>
            </div> */}

            <div
              className="cursor-pointer d-block "
              onClick={() => setShow(true)}
            >
              <HiMenu size={30} fill="#225276"  className="himenu"/>
            </div>
          </div>


          <div className="d-block ">
            <Offcanvas
              show={show}
              onHide={() => setShow(false)}
              placement="end"
              className="  "
               style={{ backgroundColor: 'transparent',border: 'none' }}
            >
              <div className=" bg-transparent" />
              <Offcanvas.Header  className=" " >
                {/* <MdClose  size={35} fill="white" className={`  cursor-pointer text-end`}  onClick={() => setShow(false)}   /> */}
               
              </Offcanvas.Header>
              <Offcanvas.Body className="bg-transparent ">
                

                <div className=" py-3 rounded-2 d-flex flex-column gap-2 text-end me-3 me-md-5">
                  <div className="d-flex justify-content-end px-4">
                <MdClose  size={38} fill="white" className={`  cursor-pointer text-end`}  onClick={() => setShow(false)}   />
                </div>
                  <Nav.Link
                    as={Link}
                    to="/"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-1 ${style.navBarlink} ${
                      active === "/" && style.navActive
                    } `}
                  >
                    Home
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/aboutus/"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/aboutus/" && style.navActive
                    }`}
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/search-campaign"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/search-campaign" && style.navActive
                    }`}
                  >
                    Campaigns
                  </Nav.Link>
                  {/* <Nav.Link
                    as={Link}
                    to="/churches"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/churches" && style.navActive
                    }`}
                  >
                    Churches
                  </Nav.Link> */}
                  {/* <Nav.Link
                    as={Link}
                    to="/pricing"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/pricing" && style.navActive
                    }`}
                  >
                    Pricing
                  </Nav.Link> */}
                  <Nav.Link
                    as={Link}
                    to="/contactus"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/contactus" && style.navActive
                    }`}
                  >
                    Contact Us
                  </Nav.Link>

                  {/* <Nav.Link
                    as={Link}
                    to="/live-streams"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/live-streams" && style.navActive
                    }`}
                  >
                    Live Streams
                  </Nav.Link> */}

                     {/* <Nav.Link
                    as={Link}
                    to="/newsletter"
                    onClick={() => setShow(false)}
                    className={`fs14 fw-medium px-4 py-2 ${style.navBarlink} ${
                      active === "/newsletter" && style.navActive
                    }`}
                  >
                    NewsLetter
                  </Nav.Link> */}

                 
                  <div>

                  <Button
                    variant="danger redbtn px-4 fs14 mx-3 mb-4"
                    onClick={() => {
                      setActive();
                      navigate("/campaign-register");
                      setShow(false)
                    }}
                  >
                    Register Your Fundraising Campaign
                  </Button>

                   {!token && (
                    <div>

                    <Button
                      variant="light"
                      className="px-4 fs14 mx-3 mt-2"
                      onClick={() => {
                        setActive();
                      window.open("https://admin.fundlife.me/", "_blank");
                        setShow(false);
                      }}
                    >
                    Campaign Admin Log In
                    </Button>
                    </div>
                  )}

                  {token && (
                    <>
                      <Button
                       ref={dropdownRef}
                        className="px-4 fs14 mx-3 mt-2 position-relative"
                        variant="light"
                        onClick={() => setShowDropdown(!showDropdown)}
                      >
                        {user?.firstName}
                           {/* <div className="position-relative" ref={dropdownRef}> */}
                      <Dropdown.Menu
                        className={` ${style.drpdown}`}
                        show={showDropdown}
                      >
                        <Dropdown.Item
                          onClick={() => {
                            handleToggle();
                            setShowDropdown(false);
                            setActive();
                            setExpanded(false); // Close the navbar only after the action
                            navigate("/profile");
                            setShow(false)
                          }}
                        >
                          View Profile
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setShowDropdown(false);
                            setExpanded(false); // Close the navbar only after the action
                            dispatch(logout({ navigate }));
                            setShow(false)
                          }}
                        >
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    {/* </div> */}
                      </Button>
                 
                    </>
                  )}
                  </div>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>
      </div>
    
    </>
  );
};

export default HomeHeader;
